import React from 'react';
import { CheckIcon, CreditCardIcon } from 'lucide-react';
import { PRICE, PRODUCT_IMAGE, offerIncludes, offerRows } from '../data/content';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offer" className="w-full bg-slate-900 px-5 py-24 text-stone-50 sm:px-14 sm:py-32" data-id="element-226" data-mp="1mmh6abszb4gw">
      <div className="mx-auto grid max-w-6xl gap-14 lg:grid-cols-12 lg:items-center" data-id="element-227" data-mp="1hph2y8nikfth">
        <div className="px-3 sm:px-0 lg:col-span-6" data-id="element-228" data-mp="ty1vk1gvr8bd">
          <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight sm:text-6xl" data-id="element-229" data-mp="u0xvtwg7a92z">
            你的完整 <em className="text-red-300" data-id="element-230" data-mp="p1uvuqf2ut1v">設計科技備課寶™</em> 教材套裝
          </h2>
          <p className="mt-6 max-w-md text-lg leading-relaxed text-stone-50/70" data-id="element-231" data-mp="13ym13gbfmyze">
            5 分鐘備好一整個學年的設計與科技課。
          </p>
          <img src={PRODUCT_IMAGE} alt="" className="mx-auto mt-12 hidden w-full max-w-sm drop-shadow-2xl lg:block" data-id="element-232" data-mp="z0aqh3dbckg4" />
        </div>

        <div id="offer-card" className="scroll-mt-16 rounded-3xl bg-stone-50 p-6 text-slate-900 shadow-2xl shadow-black/40 sm:p-11 lg:col-span-6" data-id="element-233" data-mp="2admo2wihc6tu">
          <p className="text-sm font-semibold text-slate-900/60" data-id="element-234" data-mp="pjz2nspjxdxq">完整套裝包括</p>

          <ul className="mt-5 divide-y divide-slate-900/10 border-y border-slate-900/10" data-id="element-235" data-mp="ui0kkab8r77m">
            {offerRows.map(row => <li key={row.label} className="flex gap-4 py-4" data-id="element-236" data-mp="ziwlqg47kf9c">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-700" data-id="element-237" data-mp="13ki4gi3fbnrg">
                  <CheckIcon className="h-3 w-3 text-white" strokeWidth={3} aria-hidden="true" data-id="element-238" data-mp="6usf9sdtby5l" />
                </span>
                <span data-id="element-239" data-mp="btc0fqkl15ww">
                  <span className="block font-medium leading-snug" data-id="element-240" data-mp="bqg426odupak">{row.label}</span>
                  <span className="mt-0.5 block text-sm leading-snug text-slate-900/65" data-id="element-241" data-mp="ft4c4c59vs6h">{row.detail}</span>
                </span>
              </li>)}
          </ul>

          <div className="mt-8 flex flex-col items-center gap-2 text-center sm:flex-row sm:items-end sm:justify-between sm:gap-4 sm:text-left" data-id="element-242" data-mp="3k7kpionwbekb">
            <p className="text-sm font-medium text-slate-900/70 sm:pb-2" data-id="element-243" data-mp="3o84kblkzy63a">推廣價</p>
            <p className="font-serif text-7xl leading-none tracking-tight text-slate-900 sm:text-8xl" data-id="element-244" data-mp="ve5z02hhtbpl">
              {PRICE}
            </p>
          </div>
          <p className="mt-3 flex items-center justify-center gap-2 text-sm text-slate-900/70 sm:justify-end" data-id="element-245" data-mp="1561z1j353bwg">
            <CreditCardIcon className="h-4 w-4" aria-hidden="true" data-id="element-246" data-mp="1067d7ty81ci9" />
            一次付款，無需訂閱。
          </p>

          <CtaButton label="立即取得完整套裝" className="mt-8 w-full" data-id="element-247" data-mp="chxres10cor4" />

          <ul className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs text-slate-900/60" data-id="element-248" data-mp="7i1o6v04x1cm">
            {offerIncludes.map(item => <li key={item} data-id="element-249" data-mp="lim6lq250v5l">{item}</li>)}
          </ul>
        </div>
      </div>
    </section>;
}